module.exports = __webpack_public_path__ + "build/img/logo_shadow.fe8c9ed4.png";